import React, { useEffect, useState } from "react";
import "../../css/custom.css";
import "../../css/style.css";
import { useIncomingInventoryContext } from "../../../Context/Cache/IncomingInventory/IncomingInventoryContext";
import { IncomingPrinceRangeSlider } from "../../ExternalComponent";
import newproductImage from '../../Assets/img/new.png';
import { RiArrowLeftDoubleFill } from "react-icons/ri";
import { FaFilter } from "react-icons/fa";
import { useAuthenticationContext } from "../../../Context/Authentication";

const IncomingSidebar = () => {
  const {
    categoryData,
    subCategoryData,
    brandData,
    itemCategoryCodeData,
    colorData,
    packagingData,
    selectedCategories,
    selectedSubCategories,
    selectedBrands,
    selectedItemCategoryCodes,
    setSelectedCategories,
    setSelectedSubCategories,
    setSelectedBrands,
    setSelectedItemCategoryCodes,
    selectedColors,
    setSelectedColors,
    selectedPackaging,
    setSelectedPackaging,
    handleCheckboxChange,
    fetchFilteredProducts,
    fetchDataFromCache,
    products,
    inventoryFilteredProducts,
    applyFilters,
    isRangeChanged,
    setIsRangeChanged,
    fetchAndTransformData,
    showApplyFilterOptions, setShowApplyFilterOptions,
    setNewProduct,
    newProduct,
    filternewProducts,
    isClicked, setIsClicked,
    uomData,
    selectedUOM, setSelectedUOM, handleUOMChange, isExpanded, setIsExpanded,
    toggleWidth, setIsSelectAllChecked, selectedSku,
    setSelectedSku,
    skuData,
    setSkuData,
    setFilterByLast30Days,
  } = useIncomingInventoryContext();
  const {screenSize} = useAuthenticationContext()
  const [searchCategoryInput, setSearchCategoryInput] = useState("")
  const [searchSubCategoryInput, setSearchSubCategoryInput] = useState("")
  const [searchBrandInput, setBrandSearchInput] = useState("");
  const [searchItemCategoryCodeInput, setSearchItemCategoryCodeInput] = useState("")
  const [searchColorInput, setColorSearchInput] = useState("");
  const [searchPackagingInput, setPackagingSearchInput] = useState("");
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [clearIndividualFilter, setClearIndividualFilter] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showCollapseTooltip, setShowCollapseTooltip] = useState(false);
  // const [isClicked, setIsClicked] = useState(() => {
  //   const saved = localStorage.getItem("isClickedIncoming");
  //   return saved !== null ? JSON.parse(saved) : false;
  // });
  const getLabelByValue = (value, data) => {
    const item = data.find((item) => item.value === value);
    return item ? item.label : value;
  };

  const combinedSelectedItems = [
    ...selectedCategories.map((item) => ({
      label: getLabelByValue(item, categoryData),
      value: item,
      type: "category",
      setSelected: setSelectedCategories,
    })),
    ...selectedSubCategories.map((item) => ({
      label: getLabelByValue(item, subCategoryData),
      value: item,
      type: "subcategory",
      setSelected: setSelectedSubCategories,
    })),
    ...selectedItemCategoryCodes.map((item) => ({
      label: getLabelByValue(item, itemCategoryCodeData),
      value: item,
      type: "itemCategoryCode",
      setSelected: setSelectedItemCategoryCodes,
    })),
    ...selectedColors.map((item) => ({
      label: getLabelByValue(item, colorData),
      value: item,
      type: "color",
      setSelected: setSelectedColors,
    })),
    ...selectedPackaging.map((item) => ({
      label: getLabelByValue(item, packagingData),
      value: item,
      type: "packaging",
      setSelected: setSelectedPackaging,
    })),
    ...selectedBrands.map((item) => ({
      label: getLabelByValue(item, brandData),
      value: item,
      type: "brand",
      setSelected: setSelectedBrands,
    })),
    ...selectedSku.map((item) => ({
      label: getLabelByValue(item, skuData),
      value: item,
      type: "sku",
      setSelected: setSelectedSku,
    })),
  ];
  useEffect(() => {
    localStorage.setItem("isClickedIncoming", JSON.stringify(isClicked));
  }, [isClicked]);


  const handleRemoveItem = (item) => {
    item.setSelected((prevSelectedItems) =>
      prevSelectedItems.filter((i) => i !== item.value)
    );
    setClearIndividualFilter(true)
  };

  useEffect(() => {
    if (clearIndividualFilter) {
      fetchFilteredProducts()
      setClearIndividualFilter(false)
    }
  }, [clearIndividualFilter])

  const handleRemoveAllFilter = () => {
    localStorage.setItem("isClickedIncoming", JSON.stringify(false));
    setFilterByLast30Days(false);
    setShowApplyFilterOptions(false);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedItemCategoryCodes([])
    setSelectedColors([]);
    setSelectedPackaging([]);
    setSelectedBrands([]);
    setIsRangeChanged(false);
    setIsClicked(false);
    setSelectedUOM('');
    // fetchDataFromCache()
    fetchAndTransformData();
    setIsSelectAllChecked(false);
    setSelectedSku([]);
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const filteredCategory = categoryData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchCategoryInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const filteredSubCategory = subCategoryData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchSubCategoryInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const filteredBrands = brandData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchBrandInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const filteredItemCategoryCode = itemCategoryCodeData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchItemCategoryCodeInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const filteredColors = colorData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchColorInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));

  const filteredPackaging = packagingData
    .filter(({ label }) =>
      label.toLowerCase().includes(searchPackagingInput.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));
  // Amit
  const functionToCallFetchFilterProduct = () => {
    fetchFilteredProducts();
    console.log("set setShowApplyFilterOptions == true");
    setShowApplyFilterOptions(true);
  }
  const fetchnewProduct = () => {
    filternewProducts();
    setIsClicked(true);
    localStorage.setItem("isClickedIncoming", JSON.stringify(true));
  }

  const [maxHeight, setMaxHeight] = useState(`${screenSize.height - 270}px`);
  useEffect(() => {
    if (combinedSelectedItems.length > 0 || isRangeChanged) {
      if (showApplyFilterOptions == true) {
        setMaxHeight(`${screenSize.height - 300}px`);
      } else {
        setMaxHeight(`${screenSize.height - 280}px`);
      }
    } else {
      setMaxHeight(`${screenSize.height - 240}px`);
    }
  }, [combinedSelectedItems, isRangeChanged, screenSize.height]);


  return (
    <div className="mb-10 order-2 order-lg-1" style={{ width: !isExpanded ? `270px` : `0px` }}>
      <div className="shop-sidebar-wrap mt-md-28 mt-sm-28">
        {/* <!-- sidebar categorie start --> */}
        <div className="sidebar-widget relative">
          <h6 className="font-bold py-1 cursor-pointer" onClick={toggleWidth}>
            {isExpanded ? (
              <div
                onMouseEnter={() => {
                  setShowTooltip(true);
                  setShowCollapseTooltip(false);
                }}
                onMouseLeave={() => {
                  setShowTooltip(false);
                  setShowCollapseTooltip(false);
                }}
              >
                <FaFilter className="mr-2 mt-2 z-10" />
              </div>
            ) : (
              <p
                className="flex justify-between items-center w-full"
                onMouseLeave={() => {
                  setShowTooltip(false);
                  setShowCollapseTooltip(false);
                }}
              >
                <span>
                  <FaFilter /> Filter
                </span>
                <span
                  className="font-bold text-lg"
                  onMouseEnter={() => setShowCollapseTooltip(true)}
                  onMouseLeave={() => setShowCollapseTooltip(false)}
                >
                  <RiArrowLeftDoubleFill />
                </span>
              </p>
            )}

            {showTooltip && (
              <div className="absolute bottom-full mb-0 left-1 transform -translate-x-1/3 px-2 py-1 bg-gray-700 text-white text-sm rounded-md">
                filter
              </div>
            )}

            {showCollapseTooltip && (
              <div className="absolute border mb-0 right-0 top-1 transform -translate-x-1/3 px-2 py-1 bg-gray-700 text-white text-sm rounded-md">
                collapse
              </div>
            )}
          </h6>
          {!isExpanded && (
            <aside className="filter nycfix-filter">
              <div class="">
                <nav aria-label="">
                  <div className="flex flex-wrap gap-2 pt-2 px-2">
                    {/* {combinedSelectedItems.map((item, index) => (
                  <span className="tag bg-gray-200 flex items-center">
                    {item.label}{" "}
                    <span
                      className="close-btn"
                      onClick={() => handleRemoveItem(item)}
                    >
                      &times;
                    </span>
                  </span>
                ))} */}
                  </div>
                  {(combinedSelectedItems.length > 0 || isRangeChanged) && (
                    <div className="flex justify-between px-3">
                      <span
                        className="clear-all cursor-pointer text-blue-500 mt-2 block font-semibold text-xl"
                        onClick={handleRemoveAllFilter}
                      >
                        Clear All
                      </span>
                      <span
                        className="clear-all cursor-pointer text-red-600 mt-2 block font-semibold text-xl"
                        onClick={functionToCallFetchFilterProduct}
                      >
                        Apply
                      </span>
                    </div>
                  )}

                </nav>
              </div>
              <div className="overflow-x-auto" style={{ maxHeight: maxHeight }}>
                <div className="filter-group" style={{ display: "flex", alignItems: "center" }}>
                  <button
                    className={`accordion-new flex`}
                    style={{ alignItems: "center", gap: "0.5rem" }}
                    onClick={fetchnewProduct}
                  >
                    <span>New</span>

                    <span><img className="h-10" src={newproductImage} /></span>

                  </button>

                  {isClicked ? <span
                    className="clear-all cursor-pointer text-blue-500 mt-2 block font-semibold text-xl"
                    onClick={handleRemoveAllFilter}
                  >
                    Clear
                  </span> : <></>}
                </div>
                {/* SKU */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 10 ? "active" : ""
                      }`}
                    onClick={() => toggleAccordion(10)}
                  >
                    Stock Type
                  </button>
                  <div
                    className={`panel ${activeAccordion === 10 ? "show" : ""}`}
                    style={{ padding: "8px" }} // Adjusts the panel padding
                  >
                    <ul
                      className="sku-checklist"
                      style={{ padding: "0", margin: "0" }}
                    >
                      <li
                        style={{
                          padding: "4px 0",
                          margin: "0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          value="A Stock"
                          checked={selectedSku.includes("A Stock")}
                          onChange={() => {
                            handleCheckboxChange(setSelectedSku)({
                              value: "A Stock",
                              label: "A Stock",
                            })
                          }}
                          style={{ marginRight: "8px" }} // Adds consistent space between checkbox and label
                        />
                        <label style={{ margin: "0" }}>A Stock</label>
                      </li>
                      <li
                        style={{
                          padding: "4px 0",
                          margin: "0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          value="B Stock"
                          checked={selectedSku.includes("B Stock")}
                          onChange={() => {
                            handleCheckboxChange(setSelectedSku)({
                              value: "B Stock",
                              label: "B Stock",
                            })
                          }
                          }
                          style={{ marginRight: "8px" }} // Adds consistent space between checkbox and label
                        />
                        <label style={{ margin: "0" }}>B Stock</label>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Category Filter */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 1 ? "active" : ""}`}
                    onClick={() => toggleAccordion(1)}
                  >
                    Category
                  </button>
                  <div className={`panel ${activeAccordion === 1 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Category"
                      value={searchCategoryInput}
                      onChange={(e) => setSearchCategoryInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setSearchCategoryInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredCategory.map((category, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={category.value}
                            checked={selectedCategories.includes(category.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedCategories)(category)
                            }
                          />{" "}
                          {category.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* Sub Category Filter */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 2 ? "active" : ""}`}
                    onClick={() => toggleAccordion(2)}
                  >
                    Sub Category
                  </button>
                  <div className={`panel ${activeAccordion === 2 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Sub Category"
                      value={searchSubCategoryInput}
                      onChange={(e) => setSearchSubCategoryInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setSearchSubCategoryInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredSubCategory.map((subCategory, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={subCategory.value}
                            checked={selectedSubCategories.includes(subCategory.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedSubCategories)(subCategory)
                            }
                          />{" "}
                          {subCategory.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* Brand Filter */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 3 ? "active" : ""}`}
                    onClick={() => toggleAccordion(3)}
                  >
                    Brand
                  </button>
                  <div className={`panel ${activeAccordion === 3 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Brand"
                      value={searchBrandInput}
                      onChange={(e) => setBrandSearchInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setBrandSearchInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredBrands.map((brand, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={brand.value}
                            checked={selectedBrands.includes(brand.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedBrands)(brand)
                            }
                          />{" "}
                          {brand.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* Item Category Code */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 4 ? "active" : ""}`}
                    onClick={() => toggleAccordion(4)}
                  >
                    Item Category Code
                  </button>
                  <div className={`panel ${activeAccordion === 4 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Brand"
                      value={searchItemCategoryCodeInput}
                      onChange={(e) => setSearchItemCategoryCodeInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setSearchItemCategoryCodeInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredItemCategoryCode.map((itemCategoryCode, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={itemCategoryCode.value}
                            checked={selectedItemCategoryCodes.includes(itemCategoryCode.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedItemCategoryCodes)(itemCategoryCode)
                            }
                          />{" "}
                          {itemCategoryCode.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* Color  */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 5 ? "active" : ""}`}
                    onClick={() => toggleAccordion(5)}
                  >
                    Color
                  </button>
                  <div className={`panel ${activeAccordion === 5 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Color"
                      value={searchColorInput}
                      onChange={(e) => setColorSearchInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setColorSearchInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredColors.map((color, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={color.value}
                            checked={selectedColors.includes(color.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedColors)(color)
                            }
                          />{" "}
                          {color.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* Size */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 6 ? "active" : ""}`}
                    onClick={() => toggleAccordion(6)}
                  >
                    Size
                  </button>

                  <div className={`panel ${activeAccordion === 6 ? "show" : ""}`}>
                    <div className="sidebar-widget-body" style={{ marginLeft: "-4px" }}>
                      <IncomingPrinceRangeSlider
                        type="size"
                      />
                      <div className="flex gap-2 mb-2 mx-2 justify-center items-center">
                        <label htmlFor="uom-select" className="" style={{ fontSize: '12px' }}>
                          UOM
                        </label>
                        <select
                          id="uom-select"
                          value={selectedUOM}
                          onChange={handleUOMChange}
                          style={{ fontSize: '12px' }}
                          className="bg-white border text-sm border-black py-1 w-1/4 text-gray-900"
                        >
                          <option value="">None</option>
                          {uomData.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>

                    </div>
                  </div>
                </div>
                {/* Price */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 7 ? "active" : ""}`}
                    onClick={() => toggleAccordion(7)}
                  >
                    Price
                  </button>
                  <div className={`panel ${activeAccordion === 7 ? "show" : ""}`}>
                    <div className="sidebar-widget-body" style={{ marginLeft: "-4px" }}>
                      <IncomingPrinceRangeSlider
                        type="price"
                      />
                    </div>
                  </div>
                </div>
                {/* MSRP */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 8 ? "active" : ""}`}
                    onClick={() => toggleAccordion(8)}
                  >
                    MSRP
                  </button>
                  <div className={`panel ${activeAccordion === 8 ? "show" : ""}`}>
                    <div className="sidebar-widget-body" style={{ marginLeft: "-4px" }}>
                      <IncomingPrinceRangeSlider
                        type="nyc_msrp"
                      />
                    </div>
                  </div>
                </div>
                {/* Packaging */}
                <div className="filter-group">
                  <button
                    className={`accordion ${activeAccordion === 9 ? "active" : ""}`}
                    onClick={() => toggleAccordion(9)}
                  >
                    Packaging
                  </button>
                  <div className={`panel ${activeAccordion === 9 ? "show" : ""}`}>
                    <input
                      type="text"
                      className="border border-black rounded-sm"
                      placeholder="Search Packaging"
                      value={searchPackagingInput}
                      onChange={(e) => setPackagingSearchInput(e.target.value)}
                    />
                    {/* <a href="#" onClick={() => setPackagingSearchInput("")}>
                Clear
              </a> */}
                    <ul className="scrollable-list">
                      {filteredPackaging.map((packaging, index) => (
                        <li key={index}>
                          <input
                            type="checkbox"
                            value={packaging.value}
                            checked={selectedPackaging.includes(packaging.value)}
                            onChange={() =>
                              handleCheckboxChange(setSelectedPackaging)(packaging)
                            }
                          />{" "}
                          {packaging.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </aside>
          )}

        </div>
      </div>
    </div>
  );
};

export default IncomingSidebar;
